import React, { useState, useEffect } from 'react';
import { configApi } from '../services/api';

interface CompanyInfo {
  nombre: string;
  email: string;
  telefono: string;
  direccion: string;
}

const CompanyConfigPanel: React.FC = () => {
  const [companyInfo, setCompanyInfo] = useState<CompanyInfo>({
    nombre: 'Lo Veo Por Vos',
    email: 'info@loveoporvos.com', 
    telefono: 'Tel.1171193582',
    direccion: 'Misiones 176 local 5'
  });
  
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  const loadCompanyInfo = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await configApi.getCompanyInfo();
      if (response.data.success) {
        setCompanyInfo(response.data.data);
      }
    } catch (error) {
      console.error('Error cargando info empresa:', error);
      setError('Error al cargar la información de la empresa');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!companyInfo.nombre.trim() || !companyInfo.email.trim() || 
        !companyInfo.telefono.trim() || !companyInfo.direccion.trim()) {
      setError('Todos los campos son obligatorios');
      return;
    }

    try {
      setSaving(true);
      setError('');
      setMessage('');
      
      const response = await configApi.updateCompanyInfo(companyInfo);
      
      if (response.data.success) {
        setMessage('✅ Información de empresa actualizada correctamente');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error: any) {
      console.error('Error guardando info empresa:', error);
      setError(error.response?.data?.error || 'Error al guardar la información');
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (field: keyof CompanyInfo, value: string) => {
    setCompanyInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (loading) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
        <div>⏳ Cargando configuración...</div>
      </div>
    );
  }

  return (
    <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ 
        padding: '1.5rem',
        borderBottom: '2px solid #e2e8f0',
        backgroundColor: '#f8fafc',
        borderRadius: '12px 12px 0 0'
      }}>
        <h2 style={{ 
          margin: '0',
          color: '#1e40af',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          🏢 Configuración de Empresa
        </h2>
        <p style={{ 
          margin: '0.5rem 0 0 0',
          color: '#64748b',
          fontSize: '0.9rem'
        }}>
          Esta información aparecerá en todos los reportes PDF enviados a los clientes
        </p>
      </div>

      <div style={{ padding: '1.5rem' }}>
        {message && (
          <div style={{
            background: '#dcfce7',
            color: '#166534',
            padding: '0.75rem',
            borderRadius: '6px',
            marginBottom: '1rem',
            border: '1px solid #bbf7d0'
          }}>
            {message}
          </div>
        )}

        {error && (
          <div style={{
            background: '#fef2f2',
            color: '#dc2626',
            padding: '0.75rem',
            borderRadius: '6px',
            marginBottom: '1rem',
            border: '1px solid #fecaca'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSave}>
          <div style={{ display: 'grid', gap: '1rem' }}>
            <div>
              <label style={{ 
                display: 'block',
                fontWeight: '600',
                marginBottom: '0.5rem',
                color: '#374151'
              }}>
                🏢 Nombre de la Empresa
              </label>
              <input
                type="text"
                value={companyInfo.nombre}
                onChange={(e) => handleChange('nombre', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '1rem'
                }}
                placeholder="Ej: Lo Veo Por Vos"
              />
            </div>

            <div>
              <label style={{ 
                display: 'block',
                fontWeight: '600',
                marginBottom: '0.5rem',
                color: '#374151'
              }}>
                📧 Email de Contacto
              </label>
              <input
                type="email"
                value={companyInfo.email}
                onChange={(e) => handleChange('email', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '1rem'
                }}
                placeholder="Ej: info@loveoporvos.com"
              />
            </div>

            <div>
              <label style={{ 
                display: 'block',
                fontWeight: '600',
                marginBottom: '0.5rem',
                color: '#374151'
              }}>
                📞 Teléfono
              </label>
              <input
                type="text"
                value={companyInfo.telefono}
                onChange={(e) => handleChange('telefono', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '1rem'
                }}
                placeholder="Ej: Tel.1171193582"
              />
            </div>

            <div>
              <label style={{ 
                display: 'block',
                fontWeight: '600',
                marginBottom: '0.5rem',
                color: '#374151'
              }}>
                📍 Dirección
              </label>
              <input
                type="text"
                value={companyInfo.direccion}
                onChange={(e) => handleChange('direccion', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '1rem'
                }}
                placeholder="Ej: Misiones 176 local 5"
              />
            </div>
          </div>

          <div style={{ 
            marginTop: '2rem',
            paddingTop: '1rem',
            borderTop: '1px solid #e5e7eb',
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-end'
          }}>
            <button
              type="button"
              onClick={loadCompanyInfo}
              disabled={saving || loading}
              style={{
                padding: '0.75rem 1.5rem',
                border: '2px solid #d1d5db',
                background: 'white',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                color: '#374151'
              }}
            >
              🔄 Recargar
            </button>
            
            <button
              type="submit"
              disabled={saving}
              style={{
                padding: '0.75rem 1.5rem',
                border: 'none',
                background: saving ? '#9ca3af' : '#3b82f6',
                color: 'white',
                borderRadius: '6px',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontSize: '0.9rem',
                fontWeight: '600'
              }}
            >
              {saving ? '⏳ Guardando...' : '💾 Guardar Cambios'}
            </button>
          </div>
        </form>

        <div style={{
          marginTop: '1.5rem',
          padding: '1rem',
          background: '#f1f5f9',
          borderRadius: '6px',
          fontSize: '0.85rem',
          color: '#475569'
        }}>
          <strong>💡 Nota:</strong> Los cambios se aplicarán inmediatamente a todos los nuevos reportes PDF generados para clientes.
        </div>
      </div>
    </div>
  );
};

export default CompanyConfigPanel;